import React from 'react';
import './RadioGroup.css';

const RadioGroup = ({ 
  options = [],
  value = null,
  onChange = () => {},
  variant = 'default',
  size = 'md',
  disabled = false,
  name = 'radio-group',
  className = '',
  ...props 
}) => {
  const handleChange = (optionValue) => {
    if (!disabled) {
      onChange(optionValue);
    }
  };

  // Base classes
  const baseClasses = 'radio-group';
  const variantClasses = `radio-group--${variant}`;
  const sizeClasses = `radio-group--${size}`;
  const disabledClasses = disabled ? 'radio-group--disabled' : '';
  
  return (
    <div 
      className={`${baseClasses} ${variantClasses} ${sizeClasses} ${disabledClasses} ${className}`}
      {...props}
    >
      {options.map((option, index) => {
        const isSelected = value === option.value;
        const optionId = `${name}-${index}`;
        
        return (
          <label
            key={option.value}
            htmlFor={optionId}
            className={`radio-group__option ${
              isSelected ? 'radio-group__option--selected' : ''
            }`}
          >
            <input
              type="radio"
              id={optionId}
              name={name}
              value={option.value}
              checked={isSelected}
              onChange={() => handleChange(option.value)}
              disabled={disabled}
              className="radio-group__input"
            />
            
            <div className="radio-group__indicator">
              <div className="radio-group__dot" />
            </div>
            
            <div className="radio-group__content">
              {option.label && (
                <div className="radio-group__label">{option.label}</div>
              )}
              {option.description && (
                <div className="radio-group__description">{option.description}</div>
              )}
            </div>
          </label>
        );
      })}
    </div>
  );
};

export default RadioGroup;
